import React, { useState } from "react";
import ContentFormSquelette from "../layouts/ContentFormSquelette";
import Form from "../components/Form";
import InputText from "../components/InputText";
import InputPassword from "../components/InputPassword";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowRightLong } from "react-icons/fa6";
import { env } from "../datas.config";

export default function PasswordForgotPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [login, setLogin] = useState("");
  const [resetCode, setResetCode] = useState("");
  const [maskedName, setMaskedName] = useState("");
  const [codeInput, setCodeInput] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("danger");
  const [loading, setLoading] = useState(false);

  const handleRequestReset = async (evt) => {
    evt.preventDefault();
    if (!login.trim()) return;
    setLoading(true);
    setMessage("");
    try {
      const res = await fetch(`${env.domain}/api/visitor/password-reset/request`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ login: login.trim() }),
      });
      const data = await res.json();
      if (data.status === 200) {
        setResetCode(data.resetCode);
        setMaskedName(data.maskedName);
        setStep(2);
        setMessage("");
      } else {
        setMessage(data.msg);
        setMessageType("danger");
      }
    } catch (err) {
      setMessage("Erreur de connexion au serveur.");
      setMessageType("danger");
    }
    setLoading(false);
  };

  const handleConfirmReset = async (evt) => {
    evt.preventDefault();
    if (!codeInput.trim() || !newPassword) return;
    if (newPassword !== confirmPassword) {
      setMessage("Les mots de passe ne correspondent pas.");
      setMessageType("danger");
      return;
    }
    setLoading(true);
    setMessage("");
    try {
      const res = await fetch(`${env.domain}/api/visitor/password-reset/confirm`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ code: codeInput.trim(), newPassword }),
      });
      const data = await res.json();
      if (data.status === 200) {
        setStep(3);
        setMessage(data.msg);
        setMessageType("success");
      } else {
        setMessage(data.msg);
        setMessageType("danger");
      }
    } catch (err) {
      setMessage("Erreur de connexion au serveur.");
      setMessageType("danger");
    }
    setLoading(false);
  };

  return (
    <>
      <ContentFormSquelette>
        {step === 1 && (
          <>
            <form onSubmit={handleRequestReset}>
              <Form
                faire="Mot de passe oublié"
                colClasses="col-xl-4 col-lg-5 col-md-7 col-sm-9 animate__animated animate__fadeInUpBig"
              >
                <div className="row g-3">
                  <InputText
                    label="Identifiant ou nom d'utilisateur"
                    placeholder="Saisissez votre identifiant ou nom d'utilisateur"
                    col="col-12"
                    value={login}
                    onChange={(e) => setLogin(e.target.value)}
                  />
                  {message && (
                    <div className="col-12">
                      <small className={`text-${messageType}`}>{message}</small>
                    </div>
                  )}
                  <div className="col-12">
                    <button
                      className="btn btn-primary w-100"
                      disabled={!login.trim() || loading}
                    >
                      {loading ? "Recherche..." : (
                        <>
                          Suivant <FaArrowRightLong />
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </Form>
            </form>
          </>
        )}

        {step === 2 && (
          <>
            <form onSubmit={handleConfirmReset}>
              <Form
                faire="Réinitialiser le mot de passe"
                colClasses="col-xl-5 col-lg-6 col-md-8 col-sm-10 animate__animated animate__fadeInUpBig"
              >
                <div className="row g-3">
                  <div className="col-12">
                    <div className="alert alert-info mb-0">
                      <strong>Compte trouvé : </strong>{maskedName}
                      <br />
                      <span>
                        Votre code de vérification est : <strong className="fs-5">{resetCode}</strong>
                      </span>
                      <br />
                      <small className="text-muted">Ce code expire dans 15 minutes.</small>
                    </div>
                  </div>
                  <InputText
                    label="Code de vérification"
                    placeholder="Saisissez le code à 6 chiffres"
                    col="col-12"
                    value={codeInput}
                    onChange={(e) => setCodeInput(e.target.value)}
                  />
                  <InputPassword
                    label="Nouveau mot de passe"
                    placeholder="Saisissez votre nouveau mot de passe"
                    col="col-12"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                  <div className="col-12">
                    <small className="text-muted">
                      Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule et un chiffre.
                    </small>
                  </div>
                  <InputPassword
                    label="Confirmer le mot de passe"
                    placeholder="Confirmez votre nouveau mot de passe"
                    col="col-12"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                  {message && (
                    <div className="col-12">
                      <small className={`text-${messageType}`}>{message}</small>
                    </div>
                  )}
                  <div className="col-12">
                    <button
                      className="btn btn-primary w-100"
                      disabled={
                        !codeInput.trim() ||
                        !newPassword ||
                        !confirmPassword ||
                        loading
                      }
                    >
                      {loading ? "Réinitialisation..." : "Réinitialiser le mot de passe"}
                    </button>
                  </div>
                  <div className="col-12 text-center">
                    <button
                      type="button"
                      className="btn btn-link text-muted"
                      onClick={() => {
                        setStep(1);
                        setMessage("");
                        setCodeInput("");
                        setNewPassword("");
                        setConfirmPassword("");
                      }}
                    >
                      Recommencer
                    </button>
                  </div>
                </div>
              </Form>
            </form>
          </>
        )}

        {step === 3 && (
          <Form
            faire="Mot de passe réinitialisé"
            colClasses="col-xl-4 col-lg-5 col-md-7 col-sm-9 animate__animated animate__fadeInUpBig"
          >
            <div className="row g-3">
              <div className="col-12">
                <div className="alert alert-success text-center">
                  {message}
                </div>
              </div>
              <div className="col-12">
                <button
                  className="btn btn-primary w-100"
                  onClick={() => navigate("/")}
                >
                  Se connecter
                </button>
              </div>
            </div>
          </Form>
        )}

        <div className="text-center mt-4 animate__animated animate__delay-1s animate__fadeInUp">
          <Link to="/">
            Avez-vous un compte?{" "}
            <span className="text-primary">Se connecter</span>
          </Link>
        </div>
      </ContentFormSquelette>
    </>
  );
}
